export default __webpack_public_path__ + "static/media/004-blueprint.1688bc80.svg";